import { render, staticRenderFns } from "./footer3.vue?vue&type=template&id=320b1285&scoped=true"
import script from "./footer3.vue?vue&type=script&lang=js"
export * from "./footer3.vue?vue&type=script&lang=js"
import style0 from "./footer3.vue?vue&type=style&index=0&id=320b1285&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b1285",
  null
  
)

export default component.exports